const ABONOS = (state, abonos) => {
    state.abonos = abonos;
};

const TIPOABONO = (state, tipoabono) => {
    state.tipoabono = tipoabono;
};

const SERIES = (state, series) => {
    state.series = series;
};

export default {
    ABONOS,
    TIPOABONO,
    SERIES,
};